module.exports = __webpack_public_path__ + "r-v3/img/not_devcie_alert_image.413f7a77.png";